'use client';

import { Moon, Sun } from '@/assets';
import { THEME } from '@/constants';
import { useTheme } from '@/hooks';
import { sendGAEvent, sendGTMEvent } from '@next/third-parties/google';
import { Root } from '@radix-ui/react-switch';
import { motion } from 'motion/react';
import Script from 'next/script';

const Switch = () => {
  const { theme, toggleTheme } = useTheme();

  const btnStyle = {
    backgroundColor: 'var(--surface-secondary)',
    color: 'var(--brand)',
    borderColor: 'var(--stroke-color)',
    boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  };

  return (
    <>
      <Root
        onClick={toggleTheme}
        defaultChecked={theme === THEME.LIGHT}
        className="peer relative inline-flex h-[40px] w-[76px] shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-[#02223E] data-[state=unchecked]:bg-[#F0DFC2]"
        aria-label="Toggle Dark Mode"
      >
        <motion.span
          initial={{ x: theme === THEME.LIGHT ? '100%' : 0 }}
          animate={{ x: theme === THEME.LIGHT ? '100%' : 0 }}
          layout
          transition={{ type: 'spring', stiffness: 700, damping: 25 }}
          {...{ className: 'block size-[36px] rounded-full bg-background shadow-lg' }}
        />
        <Moon className="absolute left-[5px] z-10 dark:hidden" />
        <Sun className="absolute right-[5px] z-10 hidden dark:block" />
      </Root>
      <div
        onClick={() => {
          sendGAEvent('event', 'topmate', 'click');
          sendGTMEvent({ event: 'topmate', value: 'click' });
        }}
      >
        <Script
          src="https://topmate-embed.s3.ap-south-1.amazonaws.com/v1/topmate-embed.js"
          user-profile={`https://topmate.io/embed/profile/designbynidhi?theme=${theme === THEME.LIGHT ? 'f6f3ee' : '02182b'}`}
          btn-style={JSON.stringify(btnStyle)}
          embed-version="v1"
          button-text="Let's Connect"
          custom-width="180px"
          strategy="afterInteractive"
        />
      </div>
    </>
  );
};

Switch.displayName = Root.displayName;

export { Switch };
